import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, MenuItem } from '@material-ui/core';
import Add from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';
import { ADD, EDIT, VIEW } from '../../../common/common';
import { clone } from '../../../common/utils';

const Root = styled(Box)({
    width: '100%',
    maxHeight: '500px',
    overflow: 'auto',
    '& .listItem': {
        width: '100%',
        '& .itemTitle': {
            marginTop: '10px',
            fontSize: '14px',
            color: '#9B9B9B',
        },
        '& .delBtn': {
            cursor: 'pointer',
            width: '30px',
            marginRight: '10px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .text-field': {
        width: '50%',
        paddingRight: '15px',
    },
    '& .text-field-f': {
        width: '100%',
        // paddingRight: '15px',
    },
    '& .hidden-title': {
        display: 'none'
    },
})

class PersonList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [
                // {
                //     first_name: '',
                //     last_name: '',
                //     email: '',
                //     phone: '',
                //     wechat: '',
                //     relation: '',
                // }
            ],
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const {
            listData,
        } = this.state;
        const showAddBtn = () => {
            if (!this.isDisabled()) {
                return <Button color="primary" onClick={this.handleAdd}>
                    <Add />ADD MORE Person
                </Button>
            }
        }
        return (
            <Root>
                {listData.map((row, index) => (
                    <div className="listItem" key={index}>
                        <div className={listData.length > 1 ? "itemTitle" : "itemTitle hidden-title"}>Person {index + 1}</div>
                        <div className="h">
                            <div>
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="text-field"
                                    label='First Name'
                                    value={row.first_name}
                                    name='first_name'
                                    margin="dense"
                                    variant="outlined"
                                    onChange={e => this.handleChange(e, index)}
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="text-field"
                                    label='Last Name'
                                    value={row.last_name}
                                    name='last_name'
                                    margin="dense"
                                    variant="outlined"
                                    onChange={e => this.handleChange(e, index)}
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="text-field"
                                    label='Email'
                                    value={row.email}
                                    name='email'
                                    margin="dense"
                                    variant="outlined"
                                    onChange={e => this.handleChange(e, index)}
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="text-field"
                                    label='Phone'
                                    name='phone'
                                    value={row.phone}
                                    margin="dense"
                                    variant="outlined"
                                    onChange={e => this.handleChange(e, index)}
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="text-field"
                                    label='Wechat'
                                    value={row.wechat}
                                    name='wechat'
                                    margin="dense"
                                    variant="outlined"
                                    onChange={e => this.handleChange(e, index)}
                                />
                            </div>
                            <div className="delBtn c" onClick={e => this.handleDelet(e, index)}>
                                <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
                            </div>
                        </div>
                    </div>
                ))}
                {showAddBtn()}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { data, state } = this.props;
        if (state !== ADD) {
            if (data) {
                this.setState(() => ({
                    listData: data,
                }))
            }
        }
    }
    handleChange(e, index) {
        const { value, name } = e.target;
        const { listData } = this.state;
        const obj = listData[index];
        obj[name] = value;
        this.setState(() => ({
            listData
        }));
    }
    handleAdd() {
        let listData = clone(this.state.listData);
        let obj = {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            wechat: '',
            relation: '',
        }
        listData.push(obj);
        this.setState(() => ({
            listData
        }));
    }
    handleDelet(e, index) {
        let listData = clone(this.state.listData);
        listData.splice(index, 1);
        this.setState(() => ({
            listData
        }))
    }
    getData() {
        const { listData } = this.state;
        return listData;
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
}

export default PersonList;